import React from 'react'

import Providers from '@HOCs/Providers'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'

export const wrapPageElement = ({ element, props }) => (
  <Providers context={props?.pageContext}>{element}</Providers>
)
